import React from "react";
import Topbar from "../../pages/global/Topbar";
import Sidebar from "../../pages/global/sidebar/MyProSidebar";
import { MyProSidebarProvider, useSidebarContext } from "../../pages/global/sidebar/sidebarContext";
import Main from "./Main";

function LayoutInner() {
  const { collapsed, setCollapsed } = useSidebarContext();

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
        <Topbar />
        <main style={{ flex: 1, overflowY: "auto", backgroundColor: "rgb(241, 245, 249)" }}>
          <Main />
        </main>
      </div>
    </div>
  );
}

function Layout() {
  return (
    <MyProSidebarProvider>
      <LayoutInner />
    </MyProSidebarProvider>
  );
}

export default Layout;
